import type { VocabularyItem } from './types'

/**
 * Pure substring filter (case-insensitive) over name + per-enum metadata.
 *
 * Empty / whitespace-only query returns all items unchanged.
 *
 * Matched fields per enum:
 *   PrefixItem   — name, semantics, storage
 *   AccessorItem — name, category, returnKind
 *   EventItem    — name, domain, description (optional)
 *   ActionItem   — name, category, description (optional)
 *
 * Substring-based; no fuzzy matching, no debouncing. Cheap on ~50-item arrays.
 */
export function filterItems(items: VocabularyItem[], query: string): VocabularyItem[] {
  const q = query.trim().toLowerCase()
  if (q.length === 0) return items

  return items.filter((item) => {
    if (item.name.toLowerCase().includes(q)) return true
    if ('semantics' in item && item.semantics.toLowerCase().includes(q)) return true
    if ('storage' in item && item.storage.toLowerCase().includes(q)) return true
    if ('category' in item && item.category.toLowerCase().includes(q)) return true
    if ('returnKind' in item && item.returnKind.toLowerCase().includes(q)) return true
    if ('domain' in item && item.domain.toLowerCase().includes(q)) return true
    if ('description' in item && typeof item.description === 'string' && item.description.toLowerCase().includes(q)) return true
    return false
  })
}
